import {computed} from 'vue';
import {defineStore} from 'pinia';
import {useMediaQuery} from '@malt/utils';

/**
 * Avoid multiple computations for screen-size calculations
 * */
export const useScreenSizeStore = defineStore('screen-size', () => {
    const {matchNavbarMedia, matchMedia} = useMediaQuery();

    const isMobileScreen = computed(() => matchNavbarMedia.value.max.Xs);
    const isTabletScreen = computed(() => matchNavbarMedia.value.max.Md && matchNavbarMedia.value.min.Xs);
    const isDesktopScreen = computed(() => matchNavbarMedia.value.min.Md);

    const isMobileScreenWithoutNav = computed(() => matchMedia.value.max.Xs);

    /** Both Mobile and Tablet */
    const isSmallScreen = computed(() => matchNavbarMedia.value.max.Sm);
    const isMediumScreen = computed(() => matchNavbarMedia.value.max.Md);

    const isProjectListTabletScreen = computed(() => matchNavbarMedia.value.max.Sm && matchNavbarMedia.value.min.Xs);
    const isProjectListDesktopScreen = computed(() => matchNavbarMedia.value.min.Sm);

    const screenSizeClasses = computed(() => ({
        isMobileScreen: isMobileScreen.value,
        isTabletScreen: isTabletScreen.value,
        isDesktopScreen: isDesktopScreen.value,
        isSmallScreen: isSmallScreen.value,
        isProjectListTabletScreen: isProjectListTabletScreen.value,
        isProjectListDesktopScreen: isProjectListDesktopScreen.value,
    }));

    return {
        isMobileScreen,
        isTabletScreen,
        isDesktopScreen,
        isSmallScreen,
        isMediumScreen,
        matchNavbarMedia,
        matchMedia,
        screenSizeClasses,
        isProjectListTabletScreen,
        isProjectListDesktopScreen,
        isMobileScreenWithoutNav,
    };
});
